/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_5_QInputs */

const en_cp_faq_5_q = /** @type {(inputs: Cp_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What about student data?`)
};

const id_cp_faq_5_q = /** @type {(inputs: Cp_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana dengan data mahasiswa?`)
};

/**
* | output |
* | --- |
* | "What about student data?" |
*
* @param {Cp_Faq_5_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_5_q = /** @type {((inputs?: Cp_Faq_5_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_5_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_5_q(inputs)
	return en_cp_faq_5_q(inputs)
});